<template>
  <tr data-testid="cq-promo-row">
    <td class="text-center">
      <div :title="title">
        <CheckBox
          :model-value="props.promoCode.manuallyMarkedAsSentAt != null"
          data-testid="cq-sent-checkbox"
          @update:model-value="updateStatus"
        />
      </div>
    </td>
    <td>
      <span :class="{ 'line-through': isSent }">{{ props.promoCode.code }}</span>
    </td>
    <td>
      {{ props.promoCode.userName }}
    </td>
    <td>
      {{ props.promoCode.companyName }}
    </td>
    <td class="text-center">
      {{ props.discount }}
    </td>
    <td class="text-center">
      <SvgIcon v-if="props.promoCode.ticketCount === 0" :path="mdiMinus" :size="18" class="mr-2 text-success" />
      <SvgIcon v-if="props.promoCode.ticketCount > 0" :path="mdiCheck" :size="18" class="mr-2 text-success" />
    </td>
  </tr>
</template>

<script setup lang="ts">
import { mdiMinus, mdiCheck } from '@mdi/js'
import { CheckBox } from '@ramp106/omrjs-core-ui'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import type { PromoCode } from '@/gql/myomr'
import { useManuallyMarkAsSentMutation, useManuallyMarkAsUnsentMutation } from '@/gql/myomr'

const props = defineProps<{
  promoCode: PromoCode
  discount: number
}>()

const { t, d } = useI18n()

const { mutate: manuallyMarkAsSent } = useManuallyMarkAsSentMutation()
const { mutate: manuallyMarkAsUnsent } = useManuallyMarkAsUnsentMutation()

const isSent = computed(() => props.promoCode.manuallyMarkedAsSentAt != null)

const title = computed(() => {
  if (props.promoCode.manuallyMarkedAsSentAt != null) {
    return t('InvitationQuota.table.sent_at', { date: d(props.promoCode.manuallyMarkedAsSentAt, 'dateTimeShort') })
  }
  return t('InvitationQuota.table.not_sent')
})

function updateStatus(value: boolean) {
  if (value) {
    return manuallyMarkAsSent({ promoCodeId: props.promoCode.id })
  } else {
    return manuallyMarkAsUnsent({ promoCodeId: props.promoCode.id })
  }
}
</script>
